import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { DynamicPromoRepository } from "../../../../domain/dynamic-promo-repository";
import {
  TimeSpotRuleExtentedSettings,
  TimeSpotRule,
} from "../../../../domain/timespot";
import { ChannelInfo } from "../../../../domain/channel";

@Component({
  selector: "dynamic-promo-settings",
  templateUrl: "./dynamic-promo-settings.component.html",
  styleUrls: ["./dynamic-promo-settings.component.scss"],
})
export class DynamicPromoSettingsComponent implements WizardSubstep, OnInit {
  @Input()
  channel: ChannelInfo;

  timespots: Array<TimeSpotRule> = [];
  timespotTypes: Array<{ type: number; name: string; defaultText: string }> =
    [];

  timespotDefaultsTextsPerTime: { [type: number]: string } = {};

  @Output()
  saveTimeSpotRules = new EventEmitter<Array<TimeSpotRule>>();

  constructor(private dynamicPromoRepository: DynamicPromoRepository) {}

  ngOnInit(): void {
    this.dynamicPromoRepository.getTimespotDefaults().then((result) => {
      //console.log('timespot defaults',result);
      this.timespotTypes = result;

      result.map(
        (x) => (this.timespotDefaultsTextsPerTime[x.type] = x.defaultText),
      );

      this.timespots = this.channel.timeSpotRules;
    });
  }

  canGoNext(): boolean {
    return true;
  }

  addNewTimeSpot() {
    this.timespots.push(
      new TimeSpotRule(2, this.timespotDefaultsTextsPerTime[2]),
    );
    //this.timespots.sort(this.sortByType);

    this.channel.timeSpotRules = this.timespots;

    return false;
  }

  deleteTimespot(timespotToRemove: TimeSpotRule) {
    //console.log('deleteTimespot',timespotToRemove);
    this.timespots = this.timespots.filter((timespot) => {
      return timespot != timespotToRemove;
    });

    this.channel.timeSpotRules = this.timespots;
  }

  addExtendedSettings(timespot: TimeSpotRule) {
    timespot.extentedSettings = new TimeSpotRuleExtentedSettings(0, 0);

    return false;
  }

  onTypeChange(timespot: TimeSpotRule, newType: number) {
    timespot.timeSpotType = newType;
    timespot.text = this.timespotDefaultsTextsPerTime[newType];

    this.resetExtentedSettings(timespot);
  }

  filterTimespotType(timespot: TimeSpotRule) {
    return (timespotType) => {
      return timespotType.type != 6 || timespot.timeSpotType == 6;
    };
  }

  resetExtentedSettings(timespot: TimeSpotRule) {
    timespot.extentedSettings = null;
  }

  private sortByType(a, b) {
    if (a.timeSpotType < b.timeSpotType) return -1;
    if (a.timeSpotType > b.timeSpotType) return 1;
    return 0;
  }
}
